import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import style from './style.vue';
import Upload from '@/views/components/upload/upload.vue';

@Component({
  components: { Upload },
  mixins: [style],
})
export default class Swiper extends Vue {
  @Prop({ default: () => {} })
    value: NewDisplayShopBg;

  @Prop({ default: false })
    disabled: number;

  data: NewDisplayShopBg = {};

  @Watch('value', { deep: true, immediate: true })
  watchValue(n, o) {
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      this.data = n;
    }
  }

  @Watch('value', { deep: true })
  watchData() {
    this.$emit('input', this.data);
  }

  uploadSuccess(res: HttpAPIRetItem<any>) {
    this.data.desc[0].imageUrl = res.content;
  }

  render(h) {
    return (
      <div class="site-default-img">
        <p class="title">默认店铺形象图</p>
        <el-form disabled={this.disabled}>
          <el-checkbox v-model={this.data.desc[0].isShow} true-label={1} false-label={0}>
            显示店铺形象图
          </el-checkbox>
          <div class="no-scroll">
            <Upload noDelete={false} onImgUploadSuccess={val => this.uploadSuccess(val)} img={this.data.desc[0].imageUrl} maxSize={1024} disabled={this.disabled} />
          </div>
          <p class="tip blockTip r-mt-10">注1：&nbsp;此形象图将作为默认店铺形象图，各店铺可自行修改；</p>
          <p class="tip blockTip">注2：&nbsp;建议图片大小为 750px*900px，不超过1M；</p>
        </el-form>
      </div>
    );
  }
}
